export const PLATFORMS = {
  ADMIN_PORTAL: 'admin_portal',
  THERAPIST_PORTAL: 'therapist_portal',
  PATIENT_APP: 'patient_app'
};
